module.exports = __webpack_public_path__ + "img/goods13_4.35b864a2.jpg";